import { useEffect } from 'react';
import EcoImg from 'eco-design/base/eco-img';
import EcoSpace from 'eco-design/base/eco-space';
import gtm from 'eco-design-reliance/gtm';
import { getIsPadWidth } from '@elem/utils/devices';
import useCardsShowHook from '../useHooks/useCardsShowHook';
import EFVideo from '@/components/UI/EFVideo';
import { useGlobal } from '@/utils/useGlobal';
import './index.scss';

const PHONE_PC = 'https://websiteoss.ecoflow.com/figma-uploads/1785805574926-idgl52-compressed-Frame%20128720587.webp';
const PHONE_H5 = 'https://websiteoss.ecoflow.com/figma-uploads/1785117538919-gzzya9-compressed-Frame%20128720587.webp';

const VIDEO_SRC = [
    'https://websiteoss.ecoflow.com/upload/video/1760681140401/AU_Output.mp4',
    'https://websiteoss.ecoflow.com/upload/video/1760681174289/au_outPut.webm',
];

export default function I() {
    const { useLang, Link } = useGlobal();
    const { t } = useLang('costsaving-new');

    useCardsShowHook('.cost-saving-I .CardsShow', '.cost-saving-I');

    useEffect(() => {
        const AniContainer = window?.AniContainer;
        if (!AniContainer) return;

        const isPad = getIsPadWidth();
        const layoutW = typeof window !== 'undefined' ? window.innerWidth : 375;
        const phoneEl = document.querySelector('.cost-saving-I .right-box') as HTMLElement | null;
        const phoneW = phoneEl?.offsetWidth || (isPad ? Math.min(layoutW * 0.64, 240) : 280);

        const scene = AniContainer.create({
            asyncFromTo: isPad
                ? [
                      ['.cost-saving-I .text1', { opacity: 1, y: 0 }, { opacity: 0, y: 0 }, 1],
                      ['.cost-saving-I .text2', { opacity: 0, y: 0 }, { opacity: 1, y: 0 }, 1],
                      ['.cost-saving-I .img-box', { opacity: 1, x: 0 }, { opacity: 1, x: phoneW }, 0.25],
                  ]
                : [
                      ['.cost-saving-I .text1', { opacity: 1, y: 0 }, { opacity: 0, y: -300 }, 0.6],
                      ['.cost-saving-I .text2', { opacity: 0, y: 300 }, { opacity: 1, y: 0 }, 0.6],
                      ['.cost-saving-I .img-box', { opacity: 1, x: 0 }, { opacity: 1, x: phoneW }, 0.15],
                  ],
            asyncTimeLine: isPad ? [0, 0.5, 0.5] : [0, 0.2, 0.2],
            triggerElement: '.cost-saving-I .content-ani',
            triggerHook: 1,
            offset: '100%',
            duration: '100%',
        });

        const scene2 = AniContainer.create({
            triggerElement: '.cost-saving-I .content-ani',
            triggerHook: 1,
            offset: '100%',
            onEnter: () => {
                const targetEl = document.querySelector('.cost-saving-I .video') as HTMLVideoElement;
                if (targetEl) {
                    targetEl.play();
                }
            },
            onLeave: () => {
                const targetEl = document.querySelector('.cost-saving-I .video') as HTMLVideoElement;
                if (targetEl) {
                    targetEl.pause();
                    targetEl.currentTime = 0;
                }
            },
        });

        return () => {
            scene?.destroy?.();
            scene2?.destroy?.();
        };
    }, []);

    const handleLinkClick = (buttonName: string) => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'select_product',
            list_name: t('secI_title'),
            button_name: buttonName,
            __btn_id1: 'cost-saving-I .link',
            __btn_id2: '/app',
            __btn_type: 'href',
        });
    };

    return (
        <section className={`cost-saving-I GtmModuleData-section`} id="cost-saving-I" data-section-id="cost-saving-I" data-section-title={t('secI_title')}>
            <EcoSpace />
            <div className="section-inner">
                <div className="header CardsShow">
                    <div className="badge">
                        <svg
                            className="badge-icon"
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            aria-hidden="true"
                        >
                            <rect x="4" y="1.5" width="8" height="13" rx="1.5" stroke="currentColor" strokeWidth="1.2" />
                            <path d="M6.5 12.5H9.5" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
                        </svg>
                        <span>{t('secI_badge')}</span>
                    </div>
                    <h2 className="title">{t('secI_title')}</h2>
                    <p className="desc">{t('secI_desc')}</p>
                </div>
            </div>

            <div className="content-ani">
                <div className="sticky">
                    <div className="left-box">
                        <div className="text-box">
                            <div className="text1">
                                <h3 className="card-title">{t('secI_card_title')}</h3>
                                <p className="card-desc">{t('secI_card_desc')}</p>
                                <Link className="link" href="/app" onClick={() => handleLinkClick(t('secI_link'))}>
                                    <span>{t('secI_link')}</span>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
                                        <path d="M6 3.5L10.5 8L6 12.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </Link>
                            </div>
                        </div>
                        <div className="text-box">
                            <div className="text2">
                                <h3 className="card-title">{t('secI_card2_title')}</h3>
                                <p className="card-desc">{t('secI_card2_desc')}</p>
                                <Link className="link" href="/app" onClick={() => handleLinkClick(t('secI_link'))}>
                                    <span>{t('secI_link')}</span>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
                                        <path d="M6 3.5L10.5 8L6 12.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="right-box">
                        <div className="img-box">
                            <EcoImg className="phone-img" pc={PHONE_PC} pad={PHONE_H5} h5={PHONE_H5} alt={t('secI_card_title')} />
                        </div>
                        <div className="video-box">
                            <EFVideo sources={VIDEO_SRC} width="100%" height="100%" autoPlay={false} loop={false} className="phone-video video" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
